/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Types of AI doctor workflows.
 */
export type WorkflowType = (typeof WorkflowType)[keyof typeof WorkflowType];

export const WorkflowType = {
  rx_renewal: "rx_renewal",
  diagnosis: "diagnosis",
} as const;
